export const P00045TimeZoneTypeEnum = [
  { ref: 'Africa/Abidjan', label: 'Africa/Abidjan' },
  { ref: 'Africa/Accra', label: 'Africa/Accra' },
  { ref: 'Africa/Addis Ababa', label: 'Africa/Addis Ababa' },
  { ref: 'Africa/Algiers', label: 'Africa/Algiers' },
  { ref: 'Africa/Asmara', label: 'Africa/Asmara' },
  { ref: 'Africa/Bamako', label: 'Africa/Bamako' },
  { ref: 'Africa/Bangui', label: 'Africa/Bangui' },
  { ref: 'Africa/Banjul', label: 'Africa/Banjul' },
  { ref: 'Africa/Bissau', label: 'Africa/Bissau' },
  { ref: 'Africa/Blantyre', label: 'Africa/Blantyre' },
  { ref: 'Africa/Brazzaville', label: 'Africa/Brazzaville' },
  { ref: 'Africa/Bujumbura', label: 'Africa/Bujumbura' },
  { ref: 'Africa/Cairo', label: 'Africa/Cairo' },
  { ref: 'Africa/Casablanca', label: 'Africa/Casablanca' },
  { ref: 'Africa/Ceuta', label: 'Africa/Ceuta' },
  { ref: 'Africa/Conakry', label: 'Africa/Conakry' },
  { ref: 'Africa/Dakar', label: 'Africa/Dakar' },
  { ref: 'Africa/Dar es Salaam', label: 'Africa/Dar es Salaam' },
  { ref: 'Africa/Djibouti', label: 'Africa/Djibouti' },
  { ref: 'Africa/Douala', label: 'Africa/Douala' },
  { ref: 'Africa/El Aaiun', label: 'Africa/El Aaiun' },
  { ref: 'Africa/Freetown', label: 'Africa/Freetown' },
  { ref: 'Africa/Gaborone', label: 'Africa/Gaborone' },
  { ref: 'Africa/Harare', label: 'Africa/Harare' },
  { ref: 'Africa/Johannesburg', label: 'Africa/Johannesburg' },
  { ref: 'Africa/Juba', label: 'Africa/Juba' },
  { ref: 'Africa/Kampala', label: 'Africa/Kampala' },
  { ref: 'Africa/Khartoum', label: 'Africa/Khartoum' },
  { ref: 'Africa/Kigali', label: 'Africa/Kigali' },
  { ref: 'Africa/Kinshasa', label: 'Africa/Kinshasa' },
  { ref: 'Africa/Lagos', label: 'Africa/Lagos' },
  { ref: 'Africa/Libreville', label: 'Africa/Libreville' },
  { ref: 'Africa/Lome', label: 'Africa/Lome' },
  { ref: 'Africa/Luanda', label: 'Africa/Luanda' },
  { ref: 'Africa/Lubumbashi', label: 'Africa/Lubumbashi' },
  { ref: 'Africa/Lusaka', label: 'Africa/Lusaka' },
  { ref: 'Africa/Malabo', label: 'Africa/Malabo' },
  { ref: 'Africa/Maputo', label: 'Africa/Maputo' },
  { ref: 'Africa/Maseru', label: 'Africa/Maseru' },
  { ref: 'Africa/Mbabane', label: 'Africa/Mbabane' },
  { ref: 'Africa/Mogadishu', label: 'Africa/Mogadishu' },
  { ref: 'Africa/Monrovia', label: 'Africa/Monrovia' },
  { ref: 'Africa/Nairobi', label: 'Africa/Nairobi' },
  { ref: 'Africa/Ndjamena', label: 'Africa/Ndjamena' },
  { ref: 'Africa/Niamey', label: 'Africa/Niamey' },
  { ref: 'Africa/Nouakchott', label: 'Africa/Nouakchott' },
  { ref: 'Africa/Ouagadougou', label: 'Africa/Ouagadougou' },
  { ref: 'Africa/Porto-Novo', label: 'Africa/Porto-Novo' },
  { ref: 'Africa/Sao Tome', label: 'Africa/Sao Tome' },
  { ref: 'Africa/Tripoli', label: 'Africa/Tripoli' },
  { ref: 'Africa/Tunis', label: 'Africa/Tunis' },
  { ref: 'Africa/Windhoek', label: 'Africa/Windhoek' },
  { ref: 'America/Adak', label: 'America/Adak' },
  { ref: 'America/Anchorage', label: 'America/Anchorage' },
  { ref: 'America/Anguilla', label: 'America/Anguilla' },
  { ref: 'America/Antigua', label: 'America/Antigua' },
  { ref: 'America/Araguaina', label: 'America/Araguaina' },
  {
    ref: 'America/Argentina/Buenos Aires',
    label: 'America/Argentina/Buenos Aires',
  },
  { ref: 'America/Argentina/Catamarca', label: 'America/Argentina/Catamarca' },
  { ref: 'America/Argentina/Cordoba', label: 'America/Argentina/Cordoba' },
  { ref: 'America/Argentina/Jujuy', label: 'America/Argentina/Jujuy' },
  { ref: 'America/Argentina/La Rioja', label: 'America/Argentina/La Rioja' },
  { ref: 'America/Argentina/Mendoza', label: 'America/Argentina/Mendoza' },
  {
    ref: 'America/Argentina/Rio Gallegos',
    label: 'America/Argentina/Rio Gallegos',
  },
  { ref: 'America/Argentina/Salta', label: 'America/Argentina/Salta' },
  { ref: 'America/Argentina/San Juan', label: 'America/Argentina/San Juan' },
  { ref: 'America/Argentina/San Luis', label: 'America/Argentina/San Luis' },
  { ref: 'America/Argentina/Tucuman', label: 'America/Argentina/Tucuman' },
  { ref: 'America/Argentina/Ushuaia', label: 'America/Argentina/Ushuaia' },
  { ref: 'America/Aruba', label: 'America/Aruba' },
  { ref: 'America/Asuncion', label: 'America/Asuncion' },
  { ref: 'America/Atikokan', label: 'America/Atikokan' },
  { ref: 'America/Bahia', label: 'America/Bahia' },
  { ref: 'America/Bahia Banderas', label: 'America/Bahia Banderas' },
  { ref: 'America/Barbados', label: 'America/Barbados' },
  { ref: 'America/Belem', label: 'America/Belem' },
  { ref: 'America/Belize', label: 'America/Belize' },
  { ref: 'America/Blanc-Sablon', label: 'America/Blanc-Sablon' },
  { ref: 'America/Boa Vista', label: 'America/Boa Vista' },
  { ref: 'America/Bogota', label: 'America/Bogota' },
  { ref: 'America/Boise', label: 'America/Boise' },
  { ref: 'America/Cambridge Bay', label: 'America/Cambridge Bay' },
  { ref: 'America/Campo Grande', label: 'America/Campo Grande' },
  { ref: 'America/Cancun', label: 'America/Cancun' },
  { ref: 'America/Caracas', label: 'America/Caracas' },
  { ref: 'America/Cayenne', label: 'America/Cayenne' },
  { ref: 'America/Cayman', label: 'America/Cayman' },
  { ref: 'America/Chicago', label: 'America/Chicago' },
  { ref: 'America/Chihuahua', label: 'America/Chihuahua' },
  { ref: 'America/Costa Rica', label: 'America/Costa Rica' },
  { ref: 'America/Creston', label: 'America/Creston' },
  { ref: 'America/Cuiaba', label: 'America/Cuiaba' },
  { ref: 'America/Curacao', label: 'America/Curacao' },
  { ref: 'America/Danmarkshavn', label: 'America/Danmarkshavn' },
  { ref: 'America/Dawson', label: 'America/Dawson' },
  { ref: 'America/Dawson Creek', label: 'America/Dawson Creek' },
  { ref: 'America/Denver', label: 'America/Denver' },
  { ref: 'America/Detroit', label: 'America/Detroit' },
  { ref: 'America/Dominica', label: 'America/Dominica' },
  { ref: 'America/Edmonton', label: 'America/Edmonton' },
  { ref: 'America/Eirunepe', label: 'America/Eirunepe' },
  { ref: 'America/El Salvador', label: 'America/El Salvador' },
  { ref: 'America/Fort Nelson', label: 'America/Fort Nelson' },
  { ref: 'America/Fortaleza', label: 'America/Fortaleza' },
  { ref: 'America/Glace Bay', label: 'America/Glace Bay' },
  { ref: 'America/Godthab', label: 'America/Godthab' },
  { ref: 'America/Goose Bay', label: 'America/Goose Bay' },
  { ref: 'America/Grand Turk', label: 'America/Grand Turk' },
  { ref: 'America/Grenada', label: 'America/Grenada' },
  { ref: 'America/Guadeloupe', label: 'America/Guadeloupe' },
  { ref: 'America/Guatemala', label: 'America/Guatemala' },
  { ref: 'America/Guayaquil', label: 'America/Guayaquil' },
  { ref: 'America/Guyana', label: 'America/Guyana' },
  { ref: 'America/Halifax', label: 'America/Halifax' },
  { ref: 'America/Havana', label: 'America/Havana' },
  { ref: 'America/Hermosillo', label: 'America/Hermosillo' },
  {
    ref: 'America/Indiana/Indianapolis',
    label: 'America/Indiana/Indianapolis',
  },
  { ref: 'America/Indiana/Knox', label: 'America/Indiana/Knox' },
  { ref: 'America/Indiana/Marengo', label: 'America/Indiana/Marengo' },
  { ref: 'America/Indiana/Petersburg', label: 'America/Indiana/Petersburg' },
  { ref: 'America/Indiana/Tell City', label: 'America/Indiana/Tell City' },
  { ref: 'America/Indiana/Vevay', label: 'America/Indiana/Vevay' },
  { ref: 'America/Indiana/Vincennes', label: 'America/Indiana/Vincennes' },
  { ref: 'America/Indiana/Winamac', label: 'America/Indiana/Winamac' },
  { ref: 'America/Inuvik', label: 'America/Inuvik' },
  { ref: 'America/Iqaluit', label: 'America/Iqaluit' },
  { ref: 'America/Jamaica', label: 'America/Jamaica' },
  { ref: 'America/Juneau', label: 'America/Juneau' },
  { ref: 'America/Kentucky/Louisville', label: 'America/Kentucky/Louisville' },
  { ref: 'America/Kentucky/Monticello', label: 'America/Kentucky/Monticello' },
  { ref: 'America/Kralendijk', label: 'America/Kralendijk' },
  { ref: 'America/La Paz', label: 'America/La Paz' },
  { ref: 'America/Lima', label: 'America/Lima' },
  { ref: 'America/Los Angeles', label: 'America/Los Angeles' },
  { ref: 'America/Lower Princes', label: 'America/Lower Princes' },
  { ref: 'America/Maceio', label: 'America/Maceio' },
  { ref: 'America/Managua', label: 'America/Managua' },
  { ref: 'America/Manaus', label: 'America/Manaus' },
  { ref: 'America/Marigot', label: 'America/Marigot' },
  { ref: 'America/Martinique', label: 'America/Martinique' },
  { ref: 'America/Matamoros', label: 'America/Matamoros' },
  { ref: 'America/Mazatlan', label: 'America/Mazatlan' },
  { ref: 'America/Menominee', label: 'America/Menominee' },
  { ref: 'America/Merida', label: 'America/Merida' },
  { ref: 'America/Metlakatla', label: 'America/Metlakatla' },
  { ref: 'America/Mexico City', label: 'America/Mexico City' },
  { ref: 'America/Miquelon', label: 'America/Miquelon' },
  { ref: 'America/Moncton', label: 'America/Moncton' },
  { ref: 'America/Monterrey', label: 'America/Monterrey' },
  { ref: 'America/Montevideo', label: 'America/Montevideo' },
  { ref: 'America/Montserrat', label: 'America/Montserrat' },
  { ref: 'America/Nassau', label: 'America/Nassau' },
  { ref: 'America/New York', label: 'America/New York' },
  { ref: 'America/Nipigon', label: 'America/Nipigon' },
  { ref: 'America/Nome', label: 'America/Nome' },
  { ref: 'America/Noronha', label: 'America/Noronha' },
  { ref: 'America/North Dakota/Beulah', label: 'America/North Dakota/Beulah' },
  { ref: 'America/North Dakota/Center', label: 'America/North Dakota/Center' },
  {
    ref: 'America/North Dakota/New Salem',
    label: 'America/North Dakota/New Salem',
  },
  { ref: 'America/Ojinaga', label: 'America/Ojinaga' },
  { ref: 'America/Panama', label: 'America/Panama' },
  { ref: 'America/Pangnirtung', label: 'America/Pangnirtung' },
  { ref: 'America/Paramaribo', label: 'America/Paramaribo' },
  { ref: 'America/Phoenix', label: 'America/Phoenix' },
  { ref: 'America/Port of Spain', label: 'America/Port of Spain' },
  { ref: 'America/Port-au-Prince', label: 'America/Port-au-Prince' },
  { ref: 'America/Porto Velho', label: 'America/Porto Velho' },
  { ref: 'America/Puerto Rico', label: 'America/Puerto Rico' },
  { ref: 'America/Punta Arenas', label: 'America/Punta Arenas' },
  { ref: 'America/Rainy River', label: 'America/Rainy River' },
  { ref: 'America/Rankin Inlet', label: 'America/Rankin Inlet' },
  { ref: 'America/Recife', label: 'America/Recife' },
  { ref: 'America/Regina', label: 'America/Regina' },
  { ref: 'America/Resolute', label: 'America/Resolute' },
  { ref: 'America/Rio Branco', label: 'America/Rio Branco' },
  { ref: 'America/Santarem', label: 'America/Santarem' },
  { ref: 'America/Santiago', label: 'America/Santiago' },
  { ref: 'America/Santo Domingo', label: 'America/Santo Domingo' },
  { ref: 'America/Sao Paulo', label: 'America/Sao Paulo' },
  { ref: 'America/Scoresbysund', label: 'America/Scoresbysund' },
  { ref: 'America/Sitka', label: 'America/Sitka' },
  { ref: 'America/St Barthelemy', label: 'America/St Barthelemy' },
  { ref: 'America/St Johns', label: 'America/St Johns' },
  { ref: 'America/St Kitts', label: 'America/St Kitts' },
  { ref: 'America/St Lucia', label: 'America/St Lucia' },
  { ref: 'America/St Thomas', label: 'America/St Thomas' },
  { ref: 'America/St Vincent', label: 'America/St Vincent' },
  { ref: 'America/Swift Current', label: 'America/Swift Current' },
  { ref: 'America/Tegucigalpa', label: 'America/Tegucigalpa' },
  { ref: 'America/Thule', label: 'America/Thule' },
  { ref: 'America/Thunder Bay', label: 'America/Thunder Bay' },
  { ref: 'America/Tijuana', label: 'America/Tijuana' },
  { ref: 'America/Toronto', label: 'America/Toronto' },
  { ref: 'America/Tortola', label: 'America/Tortola' },
  { ref: 'America/Vancouver', label: 'America/Vancouver' },
  { ref: 'America/Whitehorse', label: 'America/Whitehorse' },
  { ref: 'America/Winnipeg', label: 'America/Winnipeg' },
  { ref: 'America/Yakutat', label: 'America/Yakutat' },
  { ref: 'America/Yellowknife', label: 'America/Yellowknife' },
  { ref: 'Antarctica/Casey', label: 'Antarctica/Casey' },
  { ref: 'Antarctica/Davis', label: 'Antarctica/Davis' },
  { ref: 'Antarctica/DumontDUrville', label: 'Antarctica/DumontDUrville' },
  { ref: 'Antarctica/Macquarie', label: 'Antarctica/Macquarie' },
  { ref: 'Antarctica/Mawson', label: 'Antarctica/Mawson' },
  { ref: 'Antarctica/McMurdo', label: 'Antarctica/McMurdo' },
  { ref: 'Antarctica/Palmer', label: 'Antarctica/Palmer' },
  { ref: 'Antarctica/Rothera', label: 'Antarctica/Rothera' },
  { ref: 'Antarctica/Syowa', label: 'Antarctica/Syowa' },
  { ref: 'Antarctica/Troll', label: 'Antarctica/Troll' },
  { ref: 'Antarctica/Vostok', label: 'Antarctica/Vostok' },
  { ref: 'Arctic/Longyearbyen', label: 'Arctic/Longyearbyen' },
  { ref: 'Asia/Aden', label: 'Asia/Aden' },
  { ref: 'Asia/Almaty', label: 'Asia/Almaty' },
  { ref: 'Asia/Amman', label: 'Asia/Amman' },
  { ref: 'Asia/Anadyr', label: 'Asia/Anadyr' },
  { ref: 'Asia/Aqtau', label: 'Asia/Aqtau' },
  { ref: 'Asia/Aqtobe', label: 'Asia/Aqtobe' },
  { ref: 'Asia/Ashgabat', label: 'Asia/Ashgabat' },
  { ref: 'Asia/Atyrau', label: 'Asia/Atyrau' },
  { ref: 'Asia/Baghdad', label: 'Asia/Baghdad' },
  { ref: 'Asia/Bahrain', label: 'Asia/Bahrain' },
  { ref: 'Asia/Baku', label: 'Asia/Baku' },
  { ref: 'Asia/Bangkok', label: 'Asia/Bangkok' },
  { ref: 'Asia/Barnaul', label: 'Asia/Barnaul' },
  { ref: 'Asia/Beirut', label: 'Asia/Beirut' },
  { ref: 'Asia/Bishkek', label: 'Asia/Bishkek' },
  { ref: 'Asia/Brunei', label: 'Asia/Brunei' },
  { ref: 'Asia/Chita', label: 'Asia/Chita' },
  { ref: 'Asia/Choibalsan', label: 'Asia/Choibalsan' },
  { ref: 'Asia/Colombo', label: 'Asia/Colombo' },
  { ref: 'Asia/Damascus', label: 'Asia/Damascus' },
  { ref: 'Asia/Dhaka', label: 'Asia/Dhaka' },
  { ref: 'Asia/Dili', label: 'Asia/Dili' },
  { ref: 'Asia/Dubai', label: 'Asia/Dubai' },
  { ref: 'Asia/Dushanbe', label: 'Asia/Dushanbe' },
  { ref: 'Asia/Famagusta', label: 'Asia/Famagusta' },
  { ref: 'Asia/Gaza', label: 'Asia/Gaza' },
  { ref: 'Asia/Hebron', label: 'Asia/Hebron' },
  { ref: 'Asia/Ho Chi Minh', label: 'Asia/Ho Chi Minh' },
  { ref: 'Asia/Hong Kong', label: 'Asia/Hong Kong' },
  { ref: 'Asia/Hovd', label: 'Asia/Hovd' },
  { ref: 'Asia/Irkutsk', label: 'Asia/Irkutsk' },
  { ref: 'Asia/Jakarta', label: 'Asia/Jakarta' },
  { ref: 'Asia/Jayapura', label: 'Asia/Jayapura' },
  { ref: 'Asia/Jerusalem', label: 'Asia/Jerusalem' },
  { ref: 'Asia/Kabul', label: 'Asia/Kabul' },
  { ref: 'Asia/Kamchatka', label: 'Asia/Kamchatka' },
  { ref: 'Asia/Karachi', label: 'Asia/Karachi' },
  { ref: 'Asia/Kathmandu', label: 'Asia/Kathmandu' },
  { ref: 'Asia/Khandyga', label: 'Asia/Khandyga' },
  { ref: 'Asia/Kolkata', label: 'Asia/Kolkata' },
  { ref: 'Asia/Krasnoyarsk', label: 'Asia/Krasnoyarsk' },
  { ref: 'Asia/Kuala Lumpur', label: 'Asia/Kuala Lumpur' },
  { ref: 'Asia/Kuching', label: 'Asia/Kuching' },
  { ref: 'Asia/Kuwait', label: 'Asia/Kuwait' },
  { ref: 'Asia/Macau', label: 'Asia/Macau' },
  { ref: 'Asia/Magadan', label: 'Asia/Magadan' },
  { ref: 'Asia/Makassar', label: 'Asia/Makassar' },
  { ref: 'Asia/Manila', label: 'Asia/Manila' },
  { ref: 'Asia/Muscat', label: 'Asia/Muscat' },
  { ref: 'Asia/Nicosia', label: 'Asia/Nicosia' },
  { ref: 'Asia/Novokuznetsk', label: 'Asia/Novokuznetsk' },
  { ref: 'Asia/Novosibirsk', label: 'Asia/Novosibirsk' },
  { ref: 'Asia/Omsk', label: 'Asia/Omsk' },
  { ref: 'Asia/Oral', label: 'Asia/Oral' },
  { ref: 'Asia/Phnom Penh', label: 'Asia/Phnom Penh' },
  { ref: 'Asia/Pontianak', label: 'Asia/Pontianak' },
  { ref: 'Asia/Pyongyang', label: 'Asia/Pyongyang' },
  { ref: 'Asia/Qatar', label: 'Asia/Qatar' },
  { ref: 'Asia/Qyzylorda', label: 'Asia/Qyzylorda' },
  { ref: 'Asia/Riyadh', label: 'Asia/Riyadh' },
  { ref: 'Asia/Sakhalin', label: 'Asia/Sakhalin' },
  { ref: 'Asia/Samarkand', label: 'Asia/Samarkand' },
  { ref: 'Asia/Seoul', label: 'Asia/Seoul' },
  { ref: 'Asia/Shanghai', label: 'Asia/Shanghai' },
  { ref: 'Asia/Singapore', label: 'Asia/Singapore' },
  { ref: 'Asia/Srednekolymsk', label: 'Asia/Srednekolymsk' },
  { ref: 'Asia/Taipei', label: 'Asia/Taipei' },
  { ref: 'Asia/Tashkent', label: 'Asia/Tashkent' },
  { ref: 'Asia/Tbilisi', label: 'Asia/Tbilisi' },
  { ref: 'Asia/Tehran', label: 'Asia/Tehran' },
  { ref: 'Asia/Thimphu', label: 'Asia/Thimphu' },
  { ref: 'Asia/Tokyo', label: 'Asia/Tokyo' },
  { ref: 'Asia/Tomsk', label: 'Asia/Tomsk' },
  { ref: 'Asia/Ulaanbaatar', label: 'Asia/Ulaanbaatar' },
  { ref: 'Asia/Urumqi', label: 'Asia/Urumqi' },
  { ref: 'Asia/Ust-Nera', label: 'Asia/Ust-Nera' },
  { ref: 'Asia/Vientiane', label: 'Asia/Vientiane' },
  { ref: 'Asia/Vladivostok', label: 'Asia/Vladivostok' },
  { ref: 'Asia/Yakutsk', label: 'Asia/Yakutsk' },
  { ref: 'Asia/Yangon', label: 'Asia/Yangon' },
  { ref: 'Asia/Yekaterinburg', label: 'Asia/Yekaterinburg' },
  { ref: 'Asia/Yerevan', label: 'Asia/Yerevan' },
  { ref: 'Atlantic/Azores', label: 'Atlantic/Azores' },
  { ref: 'Atlantic/Bermuda', label: 'Atlantic/Bermuda' },
  { ref: 'Atlantic/Canary', label: 'Atlantic/Canary' },
  { ref: 'Atlantic/Cape Verde', label: 'Atlantic/Cape Verde' },
  { ref: 'Atlantic/Faroe', label: 'Atlantic/Faroe' },
  { ref: 'Atlantic/Madeira', label: 'Atlantic/Madeira' },
  { ref: 'Atlantic/Reykjavik', label: 'Atlantic/Reykjavik' },
  { ref: 'Atlantic/South Georgia', label: 'Atlantic/South Georgia' },
  { ref: 'Atlantic/St Helena', label: 'Atlantic/St Helena' },
  { ref: 'Atlantic/Stanley', label: 'Atlantic/Stanley' },
  { ref: 'Australia/Adelaide', label: 'Australia/Adelaide' },
  { ref: 'Australia/Brisbane', label: 'Australia/Brisbane' },
  { ref: 'Australia/Broken Hill', label: 'Australia/Broken Hill' },
  { ref: 'Australia/Currie', label: 'Australia/Currie' },
  { ref: 'Australia/Darwin', label: 'Australia/Darwin' },
  { ref: 'Australia/Eucla', label: 'Australia/Eucla' },
  { ref: 'Australia/Hobart', label: 'Australia/Hobart' },
  { ref: 'Australia/Lindeman', label: 'Australia/Lindeman' },
  { ref: 'Australia/Lord Howe', label: 'Australia/Lord Howe' },
  { ref: 'Australia/Melbourne', label: 'Australia/Melbourne' },
  { ref: 'Australia/Perth', label: 'Australia/Perth' },
  { ref: 'Australia/Sydney', label: 'Australia/Sydney' },
  { ref: 'Europe/Amsterdam', label: 'Europe/Amsterdam' },
  { ref: 'Europe/Andorra', label: 'Europe/Andorra' },
  { ref: 'Europe/Astrakhan', label: 'Europe/Astrakhan' },
  { ref: 'Europe/Athens', label: 'Europe/Athens' },
  { ref: 'Europe/Belgrade', label: 'Europe/Belgrade' },
  { ref: 'Europe/Berlin', label: 'Europe/Berlin' },
  { ref: 'Europe/Bratislava', label: 'Europe/Bratislava' },
  { ref: 'Europe/Brussels', label: 'Europe/Brussels' },
  { ref: 'Europe/Bucharest', label: 'Europe/Bucharest' },
  { ref: 'Europe/Budapest', label: 'Europe/Budapest' },
  { ref: 'Europe/Busingen', label: 'Europe/Busingen' },
  { ref: 'Europe/Chisinau', label: 'Europe/Chisinau' },
  { ref: 'Europe/Copenhagen', label: 'Europe/Copenhagen' },
  { ref: 'Europe/Dublin', label: 'Europe/Dublin' },
  { ref: 'Europe/Gibraltar', label: 'Europe/Gibraltar' },
  { ref: 'Europe/Guernsey', label: 'Europe/Guernsey' },
  { ref: 'Europe/Helsinki', label: 'Europe/Helsinki' },
  { ref: 'Europe/Isle of Man', label: 'Europe/Isle of Man' },
  { ref: 'Europe/Istanbul', label: 'Europe/Istanbul' },
  { ref: 'Europe/Jersey', label: 'Europe/Jersey' },
  { ref: 'Europe/Kaliningrad', label: 'Europe/Kaliningrad' },
  { ref: 'Europe/Kiev', label: 'Europe/Kiev' },
  { ref: 'Europe/Kirov', label: 'Europe/Kirov' },
  { ref: 'Europe/Lisbon', label: 'Europe/Lisbon' },
  { ref: 'Europe/Ljubljana', label: 'Europe/Ljubljana' },
  { ref: 'Europe/London', label: 'Europe/London' },
  { ref: 'Europe/Luxembourg', label: 'Europe/Luxembourg' },
  { ref: 'Europe/Madrid', label: 'Europe/Madrid' },
  { ref: 'Europe/Malta', label: 'Europe/Malta' },
  { ref: 'Europe/Mariehamn', label: 'Europe/Mariehamn' },
  { ref: 'Europe/Minsk', label: 'Europe/Minsk' },
  { ref: 'Europe/Monaco', label: 'Europe/Monaco' },
  { ref: 'Europe/Moscow', label: 'Europe/Moscow' },
  { ref: 'Europe/Oslo', label: 'Europe/Oslo' },
  { ref: 'Europe/Paris', label: 'Europe/Paris' },
  { ref: 'Europe/Podgorica', label: 'Europe/Podgorica' },
  { ref: 'Europe/Prague', label: 'Europe/Prague' },
  { ref: 'Europe/Riga', label: 'Europe/Riga' },
  { ref: 'Europe/Rome', label: 'Europe/Rome' },
  { ref: 'Europe/Samara', label: 'Europe/Samara' },
  { ref: 'Europe/San Marino', label: 'Europe/San Marino' },
  { ref: 'Europe/Sarajevo', label: 'Europe/Sarajevo' },
  { ref: 'Europe/Saratov', label: 'Europe/Saratov' },
  { ref: 'Europe/Simferopol', label: 'Europe/Simferopol' },
  { ref: 'Europe/Skopje', label: 'Europe/Skopje' },
  { ref: 'Europe/Sofia', label: 'Europe/Sofia' },
  { ref: 'Europe/Stockholm', label: 'Europe/Stockholm' },
  { ref: 'Europe/Tallinn', label: 'Europe/Tallinn' },
  { ref: 'Europe/Tirane', label: 'Europe/Tirane' },
  { ref: 'Europe/Ulyanovsk', label: 'Europe/Ulyanovsk' },
  { ref: 'Europe/Uzhgorod', label: 'Europe/Uzhgorod' },
  { ref: 'Europe/Vaduz', label: 'Europe/Vaduz' },
  { ref: 'Europe/Vatican', label: 'Europe/Vatican' },
  { ref: 'Europe/Vienna', label: 'Europe/Vienna' },
  { ref: 'Europe/Vilnius', label: 'Europe/Vilnius' },
  { ref: 'Europe/Volgograd', label: 'Europe/Volgograd' },
  { ref: 'Europe/Warsaw', label: 'Europe/Warsaw' },
  { ref: 'Europe/Zagreb', label: 'Europe/Zagreb' },
  { ref: 'Europe/Zaporozhye', label: 'Europe/Zaporozhye' },
  { ref: 'Europe/Zurich', label: 'Europe/Zurich' },
  { ref: 'Indian/Antananarivo', label: 'Indian/Antananarivo' },
  { ref: 'Indian/Chagos', label: 'Indian/Chagos' },
  { ref: 'Indian/Christmas', label: 'Indian/Christmas' },
  { ref: 'Indian/Cocos', label: 'Indian/Cocos' },
  { ref: 'Indian/Comoro', label: 'Indian/Comoro' },
  { ref: 'Indian/Kerguelen', label: 'Indian/Kerguelen' },
  { ref: 'Indian/Mahe', label: 'Indian/Mahe' },
  { ref: 'Indian/Maldives', label: 'Indian/Maldives' },
  { ref: 'Indian/Mauritius', label: 'Indian/Mauritius' },
  { ref: 'Indian/Mayotte', label: 'Indian/Mayotte' },
  { ref: 'Indian/Reunion', label: 'Indian/Reunion' },
  { ref: 'Pacific/Apia', label: 'Pacific/Apia' },
  { ref: 'Pacific/Auckland', label: 'Pacific/Auckland' },
  { ref: 'Pacific/Bougainville', label: 'Pacific/Bougainville' },
  { ref: 'Pacific/Chatham', label: 'Pacific/Chatham' },
  { ref: 'Pacific/Chuuk', label: 'Pacific/Chuuk' },
  { ref: 'Pacific/Easter', label: 'Pacific/Easter' },
  { ref: 'Pacific/Efate', label: 'Pacific/Efate' },
  { ref: 'Pacific/Enderbury', label: 'Pacific/Enderbury' },
  { ref: 'Pacific/Fakaofo', label: 'Pacific/Fakaofo' },
  { ref: 'Pacific/Fiji', label: 'Pacific/Fiji' },
  { ref: 'Pacific/Funafuti', label: 'Pacific/Funafuti' },
  { ref: 'Pacific/Galapagos', label: 'Pacific/Galapagos' },
  { ref: 'Pacific/Gambier', label: 'Pacific/Gambier' },
  { ref: 'Pacific/Guadalcanal', label: 'Pacific/Guadalcanal' },
  { ref: 'Pacific/Guam', label: 'Pacific/Guam' },
  { ref: 'Pacific/Honolulu', label: 'Pacific/Honolulu' },
  { ref: 'Pacific/Kiritimati', label: 'Pacific/Kiritimati' },
  { ref: 'Pacific/Kosrae', label: 'Pacific/Kosrae' },
  { ref: 'Pacific/Kwajalein', label: 'Pacific/Kwajalein' },
  { ref: 'Pacific/Majuro', label: 'Pacific/Majuro' },
  { ref: 'Pacific/Marquesas', label: 'Pacific/Marquesas' },
  { ref: 'Pacific/Midway', label: 'Pacific/Midway' },
  { ref: 'Pacific/Nauru', label: 'Pacific/Nauru' },
  { ref: 'Pacific/Niue', label: 'Pacific/Niue' },
  { ref: 'Pacific/Norfolk', label: 'Pacific/Norfolk' },
  { ref: 'Pacific/Noumea', label: 'Pacific/Noumea' },
  { ref: 'Pacific/Pago Pago', label: 'Pacific/Pago Pago' },
  { ref: 'Pacific/Palau', label: 'Pacific/Palau' },
  { ref: 'Pacific/Pitcairn', label: 'Pacific/Pitcairn' },
  { ref: 'Pacific/Pohnpei', label: 'Pacific/Pohnpei' },
  { ref: 'Pacific/Port Moresby', label: 'Pacific/Port Moresby' },
  { ref: 'Pacific/Rarotonga', label: 'Pacific/Rarotonga' },
  { ref: 'Pacific/Saipan', label: 'Pacific/Saipan' },
  { ref: 'Pacific/Tahiti', label: 'Pacific/Tahiti' },
  { ref: 'Pacific/Tarawa', label: 'Pacific/Tarawa' },
  { ref: 'Pacific/Tongatapu', label: 'Pacific/Tongatapu' },
  { ref: 'Pacific/Wallis', label: 'Pacific/Wallis' },
  { ref: 'Pacific/Wake', label: 'Pacific/Wake' },
];
